<template>
    <div class="text-center">
    <v-dialog v-model="dialog" fullscreen hide-overlay>
      <v-card>
        <v-card-title
          class="headline grey lighten-1"
          primary-title
        >Políticas de Uso</v-card-title>
        <v-card-text style="text-align: justify">
          <div class="align-center justify-center">
            <v-flex xs12 class="subtitle-1 font-weight-medium pt-10">
              <p style="text-align: justify">
                Não faça uso indevido desse serviço/sistema. Não é permitido o acesso por método diferente desta interface e das instruções fornecidas. Atente-se para a permissão por lei, inclusive regulamentos de controle de exportação e reexportação. Pode-se suspender ou deixar de fornecer este serviço em caso suspeito ou confirmado de descumprimento dos termos, políticas ou má conduta.
              </p>
              <p>
                Não é conferido direito à propriedade intelectual ou conteúdo acessado pelo usuário, bem como o uso não autorizado de marcas ou logotipos que compõe o sistema. 
              </p>

              <p>
                Não é permitido a remoção, ocultação ou alteração de quaisquer avisos legais exibidos por este sistema.
              </p>


              <!-- <br />
              <br />É preciso que você siga as políticas disponibilizadas a você dentro dos Serviços.
              <br />
              <br />Não faça uso indevido de nossos Serviços. Por exemplo, não interfira com nossos Serviços nem tente acessá-los por um método diferente da interface e das instruções que fornecemos. Você pode usar nossos serviços somente conforme permitido por lei, inclusive leis e regulamentos de controle de exportação e reexportação. Podemos suspender ou deixar de fornecer nossos Serviços se você descumprir nossos termos ou políticas ou se estivermos investigando casos de suspeita de má conduta.
              <br />
              <br />O uso de nossos Serviços não lhe confere a propriedade sobre direitos de propriedade intelectual sobre os nossos Serviços ou sobre o conteúdo que você acessar. Você não pode usar conteúdos de nossos Serviços a menos que obtenha permissão do proprietário de tais conteúdos ou que o faça por algum meio permitido por lei. Estes termos não conferem a você o direito de usar quaisquer marcas ou logotipos utilizados em nossos Serviços. Não remova, oculte ou altere quaisquer avisos legais exibidos em ou junto a nossos Serviços.
              <br />
              <br /> -->
            </v-flex>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-form ref="form">
            <v-row>
                <v-checkbox
                v-model="aceite"
                color="success"
                required
                label="Eu aceito os termos e condições de uso do sistema"
                :rules="[v => v || 'Você irá prosseguir somente se aceitar os termos e as condições de uso!']"
            ></v-checkbox>

            <v-btn class="mt-4 ml-5" color="primary" @click="validate">Prosseguir</v-btn>
            </v-row>
          </v-form>
          <v-spacer></v-spacer>
          <!-- <v-form ref="form">
                <v-row>
                    <v-col cols="12">
                        <v-checkbox
                v-model="aceite"
                color="success"
                required
                label="Eu aceito os termos e condições de uso do sistema"
                :rules="[v => !!v || 'You must agree to continue!']"
                ></v-checkbox>

                <v-btn color="primary" @click="validate">Prosseguir</v-btn>
                    </v-col>
                </v-row>
          </v-form>-->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
    name:"TermsOfUseTarm",
     data: () => ({
        dialog: true,
        aceite: false
    }),
    methods: {
        validate() {
            let validateForm = this.$refs.form.validate();
            this.$emit('validate',validateForm)
        }
    }
}
</script>